import { DatePipe, formatDate } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { CommonService } from 'src/app/Service/Common.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-message-status-summary',
  templateUrl: './message-status-summary.component.html',
  styleUrls: ['./message-status-summary.component.css']
})
export class MessageStatusSummaryComponent implements OnInit {


  public reportServer!: string|null;
  public reportUrl!: string;
  public showParameters!: string;
  public parameters: any;
  public language!: string;
  public height!: number;
  public width!: number;
  public toolbar!: string;
  public date!: Date;
  projectId!: number ;
  memberId!: number ;
  groupId!: number ;
  hasSuperView: boolean = false;
  public buttonType = 'MyMessages';

  constructor(private commonService: CommonService, public datepipe: DatePipe) { }

  ngOnInit() {
    this.memberId = this.commonService.getLoggedInUserId();
    this.projectId = this.commonService.getProjectId();
    this.groupId = this.commonService.getLoggedInUserGroupId()
    this.callMemberRoleandFeature();
    this.EmbedSSRSReport();
  }

  async callMemberRoleandFeature() {
    await this.commonService.getProjectMemberFeatures(this.projectId, this.memberId, this.groupId).subscribe((result1: any[]) => {
      this.hasSuperView = result1.some(data => data.feature_Desc == 'Msg Super View');
    });
  }

  public onValChange(val: string) {
    this.buttonType = val;
    this.reportServer = null;
    this.reportUrl = '';
    this.parameters = null;
    setTimeout(() => {
      this.EmbedSSRSReport();
    }, 50);
  }

  public EmbedSSRSReport() {
    this.date = new Date();
    this.reportServer = environment.reportHost + "EIP40Reports/EIP4EDMS/EDMS/MessageStatusSummary";
    this.reportUrl = environment.reportHost + "EIP40Reports/EIP4EDMS/EDMS/MessageStatusSummary";
    this.showParameters = "false";
    this.parameters = {
      "Project_Id": this.commonService.getProjectId(),
      "Group_Id": this.commonService.getLoggedInUserGroupId(),
      "Member_Id": this.buttonType == "MyMessages" ? this.memberId : null,
      "To_Date": formatDate(this.date, 'MM/dd/yyyy', 'en-US'),
      "Message_Type": null,
      "Message_Type_Desc": null,
      "Trans_Type": 'Fetch',
      "Project_Description": null,
      "Project_Short_Desc": null,
      "Project_URL": null,
      "Project_Logo_URL": null,
      "UserId": 0,
      "Active_Tag": true,
      "error": null,
      "Job_Code": null,
      "Project_Code": null,
      "Search_Text": null,
    };
    this.language = "en-us";
    this.width = 1000;
    this.height = 620;
    this.toolbar = "true";
  }

}
